module.exports = __webpack_public_path__ + "img/push-fei-tip.a45b88a7.png";